import { ErrorMessage, Formik } from 'formik';
import React from 'react';
import { Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { ChangePasswordRequest } from '../../../../models/account/change-password/ChangePasswordRequest';
import { changePasswordActions } from '../../../../store/account/actions';
import { changePasswordValidationSchema } from '../../../../blocks/validation/validationSchema';
import I18n from '../../../../blocks/localization';
import { connect } from 'react-redux';

type Props = typeof mapDispatchToProps;

const ChangePasswordTab = (props: Props) => {
    const initialChangePasswordRequest = { oldPassword: '', newPassword: '', confirmPassword: '' } as ChangePasswordRequest;

    const handleFormSubmit = (changePasswordRequest: ChangePasswordRequest) => {
        props.changePassword(changePasswordRequest);
    }

    return (
        <>
            <Row>
                <Col xl={6} lg={12}>
                    <Formik
                        validationSchema={changePasswordValidationSchema}
                        validateOnBlur
                        initialValues={initialChangePasswordRequest}
                        enableReinitialize
                        onSubmit={(values) => handleFormSubmit(values)}>
                        {({ handleChange, handleSubmit, values, errors, touched }) => (
                            <form onSubmit={handleSubmit}>
                                <FormGroup className="row">
                                    <Label className="col-form-label col-sm-3">{I18n.t('myProfile.tabs.changePassword.form.oldPassword')}</Label>
                                    <div className="col-sm-9">
                                        <Input type="password" name="oldPassword" onChange={handleChange}
                                            className={errors.oldPassword && touched.oldPassword ? ' is-invalid' : ''} />
                                        <ErrorMessage name="oldPassword" component="div" className="invalid-feedback" />
                                    </div>
                                </FormGroup>
                                <FormGroup className="row">
                                    <Label className="col-form-label col-sm-3">{I18n.t('myProfile.tabs.changePassword.form.newPassword')}</Label>
                                    <div className="col-sm-9">
                                        <Input type="password" name="newPassword" onChange={handleChange}
                                            className={errors.newPassword && touched.newPassword ? ' is-invalid' : ''} />
                                        <ErrorMessage name="newPassword" component="div" className="invalid-feedback" />
                                    </div>
                                </FormGroup>
                                <FormGroup className="row">
                                    <Label className="col-form-label col-sm-3">{I18n.t('myProfile.tabs.changePassword.form.confirmPassword')}</Label>
                                    <div className="col-sm-9">
                                        <Input type="password" name="confirmPassword" onChange={handleChange}
                                            className={errors.confirmPassword && touched.confirmPassword ? ' is-invalid' : ''} />
                                        <ErrorMessage name="confirmPassword" component="div" className="invalid-feedback" />
                                    </div>
                                </FormGroup>

                                <Button type="submit" color="primary" onClick={handleSubmit}>{I18n.t('myProfile.tabs.changePassword.button')}</Button>
                            </form>
                        )}
                    </Formik>
                </Col>
            </Row>
        </>
    );
};

const mapDispatchToProps = {
    changePassword: changePasswordActions.request
};

export default connect(null, mapDispatchToProps)(ChangePasswordTab as any);
